import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { ContainerModalConsultaSalida, HeaderModal } from "./localStyle";
import { hideSegundoModal } from "_+_Portal/context/Actions/segundoModal/segundoModal";
import { PortalContext } from "_+_Portal/context/Provider";
import { GlobalContext } from "global/context/Provider";

const ModalConsultaSalida = ({ loop, setNewInterval }) => {
  const { segundoModalDispatch, resetPortalContext } = useContext(PortalContext);
  const { resetGlobalContext } = useContext(GlobalContext);
  const history = useHistory();
  const [time, setTime] = useState(10);
  const [active, setActive] = useState(false);
  const [idInterval, setIdInterval] = useState(null);

  const currentRoute = useLocation().pathname.replace(
    "/autocheckinDesktop/",
    ""
  );
  const sinTimer = [
    "atenciosinturnoprevio",
    "escaneoorden",
    "revisionorden",
    "validacioncoberturalabo",
    "validaciontoken",
  ];

  const handleClickSuccess = () => {
    hideSegundoModal()(segundoModalDispatch);
    let id = loop();
    setNewInterval(id);
    clearInterval(idInterval);
  };
  const handleClickDanger = () => {
    clearInterval(idInterval);
    hideSegundoModal()(segundoModalDispatch);
    resetGlobalContext(0);
    resetPortalContext(0);
    history.push("/");
  };

  // Contador regresivo con control de montaje para evitar memory leaks
  useEffect(() => {
    let isMounted = true;
    let interval = null;

    const newLoop = () => {
      let newTime = time;
      interval = setInterval(() => {
        if (newTime > 0) {
          newTime = newTime - 1;
          if (isMounted) {
            setTime(newTime);
          }
        } else {
          clearInterval(interval);
          if (isMounted) {
            handleClickDanger();
          }
        }
      }, 1000);
      if (isMounted) {
        setIdInterval(interval);
      }
      return interval;
    };

    if (time > 0 && !active && isMounted) {
      newLoop();
      setActive(true);
    }

    return () => {
      isMounted = false;
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  useEffect(() => {
    const str = currentRoute.toLowerCase();
    const isFail = sinTimer.includes(str);
    if (isFail) {
      clearInterval(idInterval);
      hideSegundoModal()(segundoModalDispatch);
    }
  }, [currentRoute]);

  return (
    <>
      <HeaderModal className="rb24t c-white">
        Tiempo de Espera{" "}
        <span className="cierreModal" onClick={handleClickSuccess}>
          X
        </span>
      </HeaderModal>
      <ContainerModalConsultaSalida>
        {/* <span dangerouslySetInnerHTML={{__html:title }}/> */}
        <span dangerouslySetInnerHTML={{ __html: "¿Necesita más tiempo?" }} />
        <div className="container-btn">
          <button onClick={handleClickDanger} className="danger">
            NO {`(${time})`}
          </button>
          <button onClick={handleClickSuccess} className="success">
            SI
          </button>
        </div>
      </ContainerModalConsultaSalida>
    </>
  );
};

export default ModalConsultaSalida;
